import { useMemo, useState } from "react";
import { useAuth } from "../auth/AuthContext";
import { ProjectsUpload } from "./ProjectsUpload";
import { CertificationUploadPanel } from "./CertificationUploadPanel";
import { ExportRRs } from "./ExportRRs";
import { RRSnapshotDiff } from "./RRSnapshotDiff";
import { BeachUpload } from "./BeachUpload";
import { BeachMatchReset } from "./BeachMatchReset";
import { FeatureFlagsPanel } from "./FeatureFlagsPanel";

type AdminTab = "rrUpload" | "rrDiff" | "certUpload" | "beachUpload" | "beachReset" | "export" | "featureFlags";

const ADMIN_TAB_LABELS: Record<AdminTab, string> = {
  rrUpload: "RR Upload",
  rrDiff: "RR Snapshot Diff",
  certUpload: "Certification Upload",
  beachUpload: "Beach Upload",
  beachReset: "Beach Match Reset",
  export: "Export",
  featureFlags: "Feature Flags",
};

export function AdminDashboard() {
  const { hasRole } = useAuth();
  const isRoot = hasRole("root");
  const isAdmin = hasRole("admin") || isRoot;

  const baseTabs: AdminTab[] = ["rrUpload", "rrDiff", "certUpload", "beachUpload", "beachReset"];
  let tabs: AdminTab[] = baseTabs;

  if (isAdmin) {
    tabs = [...tabs, "export"];
  }

  if (isRoot) {
    tabs = [...tabs, "featureFlags"];
  }
  const [activeTab, setActiveTab] = useState<AdminTab>(tabs[0]);
  const safeTabs = useMemo(() => tabs, [tabs]);

  return (
    <>
      <nav className="tabs">
        {safeTabs.map((tab) => (
          <button
            key={tab}
            type="button"
            className={`tab-button ${tab === activeTab ? "active" : ""}`}
            onClick={() => setActiveTab(tab)}
          >
            {ADMIN_TAB_LABELS[tab]}
          </button>
        ))}
      </nav>
      <section className="tab-content">
        {activeTab === "rrUpload" && <ProjectsUpload />}
        {activeTab === "rrDiff" && <RRSnapshotDiff />}
        {activeTab === "certUpload" && <CertificationUploadPanel />}
        {activeTab === "beachUpload" && <BeachUpload />}
        {activeTab === "beachReset" && <BeachMatchReset />}
        {activeTab === "export" && <ExportRRs />}
        {activeTab === "featureFlags" && <FeatureFlagsPanel />}
      </section>
    </>
  );
}
